<template>
  <h5 class="body-2-bold">
    {{
      i18n(
        isOneWay(productReturn)
          ? translations.oneWayTitle
          : translations.twoWayTitle,
      )
    }}
  </h5>

  <p class="text-static-default-low">
    {{
      i18n(translations.creationDate, {
        date: new Date(productReturn.creationDate),
      })
    }}
  </p>

  <p class="text-static-default-low">
    {{
      i18n(translations.shipmentSource, {
        source: productReturn.shipment?.shipmentLabel?.source || 'MANUAL',
      })
    }}
  </p>

  <p
    v-if="productReturn.isHandledByBackrepair"
    class="text-static-default-low flex items-center gap-4"
  >
    <IconTools class="h-16 w-16" />
    {{ i18n(translations.backRepair) }}
  </p>

  <p class="text-static-default-low">
    <PickedUpDate
      v-if="productReturn.datePickedUp"
      :date="productReturn.datePickedUp"
      :is-handled-by-backrepair="productReturn.isHandledByBackrepair"
      :is-one-way="isOneWay(productReturn)"
    />
  </p>

  <p class="text-static-default-low">
    <DeliveredDate
      v-if="productReturn.dateDelivered"
      :date="productReturn.dateDelivered"
      :is-handled-by-backrepair="productReturn.isHandledByBackrepair"
      :is-one-way="isOneWay(productReturn)"
    />
  </p>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconTools } from '@ds/icons/IconTools'

import type { ProductReturn } from '~/api/care-folders/types/product-return'

import DeliveredDate from './DeliveredDate.vue'
import PickedUpDate from './PickedUpDate.vue'
import translations from './ProductReturn.translations'
import { isOneWay } from './ProductReturn.utils'

const i18n = useI18n()

defineProps<{
  productReturn: ProductReturn
}>()
</script>
